var _style, _path, _defs, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPremiumCrown = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 88.7 54.2",
  style: {
    enableBackground: "new 0 0 88.7 54.2"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000052070141239905121260000016001375347419989941_);}\n\t.st2{fill:url(#SVGID_00000101799100642464759520000002619694578312114343_);}\n\t.st3{fill:url(#SVGID_00000016791508585243268160000000087457613133367683_);}\n\t.st4{fill:url(#SVGID_00000021813447885995063000000007058715634485824951_);}\n\t.st5{fill:url(#SVGID_00000069398808924566142810000017694617232104213686_);}\n\t.st6{fill:url(#SVGID_00000095308581671367182100000012873430959170228156_);}\n\t.st7{fill:url(#SVGID_00000034797513381893599380000005801467672801020088_);}\n\t.st8{fill:url(#SVGID_00000028312087822725416610000011644684234074464644_);}\n\t.st9{fill:url(#SVGID_00000086666917076135427020000002516275265354860732_);}\n\t.st10{clip-path:url(#SVGID_00000163757812418842813620000016076633066996283788_);}\n\t.st11{opacity:0.35;fill:#FFFF73;enable-background:new    ;}\n\t.st12{fill:#FFF9B3;}\n")), /*#__PURE__*/React.createElement("g", {
  id: "Layer_2_00000101094768674093978850000009994195271227638172_"
}, /*#__PURE__*/React.createElement("g", {
  id: "premium-crown"
}, /*#__PURE__*/React.createElement("g", {
  id: "premium-crown-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "crown"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 33.555,
  y1: 54.3,
  x2: 33.555,
  y2: 18.13,
  gradientTransform: "matrix(1 0 0 -1 8.77 56.07)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#EAD728"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#F4A721"
  }
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M66.9,40.2H17.8l4.6-7.3c0.7,0.5,1.6,0.8,2.5,0.8c2.6,0,4.7-2.1,4.7-4.7c0-1.6-0.9-3.1-2.2-4L42.3,0.8 l15,24.1c-1.4,0.8-2.3,2.3-2.3,4c0,2.6,2.1,4.7,4.7,4.7c0.9,0,1.8-0.3,2.6-0.8L66.9,40.2z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_00000110450586348156674190000008109850902069918108_",
  gradientUnits: "userSpaceOnUse",
  x1: 54.235,
  y1: 54.3,
  x2: 54.235,
  y2: 18.13,
  gradientTransform: "matrix(1 0 0 -1 8.77 56.07)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#EAD728"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#F4A721"
  }
})), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "url(#SVGID_00000110450586348156674190000008109850902069918108_)"
  },
  d: "M75.9,10.2l-4.8,30H50.1l6.6-7.7 c0.8,0.7,1.9,1.1,3,1.1c0.9,0,1.8-0.3,2.6-0.8c2.1-1.4,2.8-4.3,1.4-6.4c-0.2-0.4-0.5-0.7-0.9-1L75.9,10.2z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_00000065760764015676814150000018277415960979085712_",
  gradientUnits: "userSpaceOnUse",
  x1: 12.915,
  y1: 54.3,
  x2: 12.915,
  y2: 18.13,
  gradientTransform: "matrix(1 0 0 -1 8.77 56.07)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#EAD728"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#F4A721"
  }
})), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "url(#SVGID_00000065760764015676814150000018277415960979085712_)"
  },
  d: "M34.6,40.2H13.5l-4.8-30l13.1,15.2 c-2,1.6-2.2,4.5-0.6,6.5c0.3,0.4,0.7,0.7,1.1,1c0.7,0.5,1.6,0.8,2.5,0.8c1.1,0,2.2-0.4,3.1-1.1L34.6,40.2z"
})), /*#__PURE__*/React.createElement("g", {
  id: "text"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_00000066497083648971349440000017925035870019074207_",
  gradientUnits: "userSpaceOnUse",
  x1: 7.7593,
  y1: 60.27,
  x2: 7.7593,
  y2: 3.25,
  gradientTransform: "matrix(1 0 0 -1 8.77 56.07)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#EAD728"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#F4A721"
  }
})), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "url(#SVGID_00000066497083648971349440000017925035870019074207_)"
  },
  d: "M18.5,46.1c1.5,0.7,2.1,2.4,1.5,3.9 c-0.3,0.7-0.8,1.2-1.5,1.5c-0.6,0.3-1.3,0.4-1.9,0.4h-1.7v2.3h-1.9v-8.4h3.6C17.2,45.7,17.8,45.8,18.5,46.1z M17.8,49.8 c0.3-0.3,0.5-0.7,0.5-1.1c0-0.4-0.1-0.8-0.5-1.1c-0.4-0.3-0.9-0.4-1.3-0.4h-1.6v2.9h1.6C16.9,50.2,17.4,50.1,17.8,49.8z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_00000055682408591653252020000017004172341206888083_",
  gradientUnits: "userSpaceOnUse",
  x1: 16.49,
  y1: 60.27,
  x2: 16.49,
  y2: 3.25,
  gradientTransform: "matrix(1 0 0 -1 8.77 56.07)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#EAD728"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#F4A721"
  }
})), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "url(#SVGID_00000055682408591653252020000017004172341206888083_)"
  },
  d: "M26.9,54.1l-1.6-2.3h-1.8v2.3h-1.9 v-8.4h3.6c0.7,0,1.3,0.1,1.9,0.4c1.1,0.4,1.8,1.5,1.7,2.7c0,0.6-0.1,1.1-0.5,1.6c-0.3,0.4-0.8,0.8-1.3,1l1.9,2.7H26.9z  M26.4,47.7c-0.4-0.3-0.9-0.4-1.3-0.4h-1.6v2.9h1.6c0.5,0,0.9-0.1,1.3-0.4c0.3-0.3,0.5-0.7,0.5-1.1 C26.9,48.3,26.7,47.9,26.4,47.7L26.4,47.7z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_00000183222917096042392670000003465278170923305134_",
  gradientUnits: "userSpaceOnUse",
  x1: 24.84,
  y1: 60.27,
  x2: 24.84,
  y2: 3.25,
  gradientTransform: "matrix(1 0 0 -1 8.77 56.07)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#EAD728"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#F4A721"
  }
})), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "url(#SVGID_00000183222917096042392670000003465278170923305134_)"
  },
  d: "M36.9,52.5v1.5h-6.5v-8.4h6.3v1.6h-4.4 v1.8h3.9v1.5h-3.9v1.9L36.9,52.5z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_00000001655932494296651610000010302422623661920433_",
  gradientUnits: "userSpaceOnUse",
  x1: 34.36,
  y1: 60.27,
  x2: 34.36,
  y2: 3.25,
  gradientTransform: "matrix(1 0 0 -1 8.77 56.07)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#EAD728"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#F4A721"
  }
})), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "url(#SVGID_00000001655932494296651610000010302422623661920433_)"
  },
  d: "M46,54.1v-5l-2.5,4.1h-0.9l-2.5-4v4.9 h-1.8v-8.4H40l3.1,5.2l3.1-5.2h1.6v8.4L46,54.1z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_00000013914465900277615310000016695454952579654809_",
  gradientUnits: "userSpaceOnUse",
  x1: 42.05,
  y1: 60.27,
  x2: 42.05,
  y2: 3.25,
  gradientTransform: "matrix(1 0 0 -1 8.77 56.07)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#EAD728"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#F4A721"
  }
})), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "url(#SVGID_00000013914465900277615310000016695454952579654809_)"
  },
  d: "M49.9,45.7h1.9v8.4h-1.9V45.7z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_00000005248064925495479340000006371489859955741616_",
  gradientUnits: "userSpaceOnUse",
  x1: 48.7812,
  y1: 60.27,
  x2: 48.7812,
  y2: 3.25,
  gradientTransform: "matrix(1 0 0 -1 8.77 56.07)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#EAD728"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#F4A721"
  }
})), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "url(#SVGID_00000005248064925495479340000006371489859955741616_)"
  },
  d: "M54.8,53.2c-0.7-0.8-1.1-1.8-1-2.8 v-4.7h2v4.6c0,1.5,0.6,2.2,1.9,2.2c0.5,0,1-0.2,1.3-0.5c0.4-0.5,0.5-1.1,0.5-1.7v-4.7h1.9v4.7c-0.1,2.2-2,3.9-4.2,3.8 C56.3,54.1,55.4,53.8,54.8,53.2z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_00000095299449696868126770000011620783626077950369_",
  gradientUnits: "userSpaceOnUse",
  x1: 59.245,
  y1: 60.27,
  x2: 59.245,
  y2: 3.25,
  gradientTransform: "matrix(1 0 0 -1 8.77 56.07)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#EAD728"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#F4A721"
  }
})), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "url(#SVGID_00000095299449696868126770000011620783626077950369_)"
  },
  d: "M70.9,54.1v-5l-2.5,4.2h-0.9l-2.5-4 v4.8h-1.8v-8.4h1.6l3.1,5.2l3.1-5.2h1.6l0.1,8.4H70.9z"
})), /*#__PURE__*/React.createElement("g", {
  id: "shimmer-group"
}, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_00000057123043414304026040000017916570107781387396_",
  d: "M63,25.4c2,1.7,2.2,4.6,0.5,6.5 c-0.3,0.3-0.6,0.6-1,0.9c-0.8,0.5-1.7,0.8-2.6,0.8c-2.6,0-4.7-2.1-4.7-4.7c0-1.7,0.9-3.2,2.3-4l-15-24.1l-15,24.1 c1.4,0.8,2.3,2.4,2.2,4c0,2.6-2,4.6-4.6,4.7c0,0-0.1,0-0.1,0c-0.9,0-1.8-0.3-2.5-0.8c-2.2-1.3-2.8-4.2-1.5-6.3 c0.3-0.4,0.6-0.8,1-1.1L9,10.1l4.8,30h57.7l4.8-30L63,25.4z"
}))), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_00000076605675108803783360000008596367539617670556_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_00000057123043414304026040000017916570107781387396_",
  style: {
    overflow: "visible"
  }
})), /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#SVGID_00000076605675108803783360000008596367539617670556_)"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "shimmer",
  className: "catpr-shimmer",
  d: "M68.4,0L21.5,46.8H0L46.8,0.1L68.4,0z M77.1,0.1L30.3,46.8h11.5L88.7,0L77.1,0.1z",
  fill: "#ffff73",
  opacity: 0.35
}))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  id: "flare1",
  className: "catpr-flare1",
  d: "M36.8,15.2l5.4-0.8l-5.6-0.9c-1-0.2-1.8-1-1.9-2L33.7,2l-0.8,9.4c-0.1,1-0.8,1.9-1.9,2.1 l-5.5,1l5.5,0.7c1.1,0.1,1.9,1,2,2.1l1,9.8l0.9-9.8C34.9,16.2,35.7,15.3,36.8,15.2z",
  fill: "#fff9b3"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  id: "flare2",
  className: "catpr-flare2",
  d: "M74,36.4l3.7-0.5l-3.8-0.7c-0.7-0.1-1.2-0.7-1.3-1.4l-0.7-6.4l-0.5,6.4 c-0.1,0.7-0.6,1.3-1.3,1.4l-3.8,0.7l3.7,0.5c0.7,0.1,1.3,0.7,1.4,1.4l0.7,6.7l0.6-6.7C72.7,37.1,73.3,36.5,74,36.4z",
  fill: "#fff9b3"
}))))));
export default SvgPremiumCrown;